import { registerPlugin } from "@capacitor/core"
import type { BillingPlugin } from "./definitions"

// Register the plugin with Capacitor
const Billing = registerPlugin<BillingPlugin>("BillingPlugin", {
	web: () => import("./web").then((m) => new m.BillingWeb()),
})

export { Billing }

// Export types from definitions
export * from "./definitions"
